import baseApi from './base';

// 获取业务类型列表
const fetchBusinessList = () =>
  baseApi.request({
    method: 'get',
    url: '/ci-type'
  });

// 获取业务类型详情
const fetchOneBusiness = id =>
  baseApi.request({
    method: 'get',
    url: `/ci-type/${id}`
  });

// 新增业务类型
const createOne = data =>
  baseApi.request({
    method: 'post',
    url: '/ci-type',
    data
  });

// 修改业务类型
const modifyOne = data =>
  baseApi.request({
    method: 'patch',
    url: `/ci-type/${data.id}`,
    data
  });

// 删除业务类型
const deleteOne = id =>
  baseApi.request({
    method: 'delete',
    url: `/ci-type/${id}`
  });

// 新增二级类型
const createSecondType = (id, data) =>
  baseApi.request({
    method: 'post',
    url: `/ci-type/${id}/second-type`,
    data
  });

// 修改二级类型
const modifySecondType = (id, data) =>
  baseApi.request({
    method: 'patch',
    url: `/ci-type/${id}/second-type/${data.id}`,
    data
  });

// 删除二级类型
const deleteSecondType = (id, secondTypeId) =>
  baseApi.request({
    method: 'delete',
    url: `/ci-type/${id}/second-type/${secondTypeId}`
  });

// 查询二级类型列表
const fetchSecondTypeList = (id, params) =>
  baseApi.request({
    method: 'get',
    url: `/ci-type/${id}/second-type`,
    params
  });

export {
  fetchBusinessList,
  fetchOneBusiness,
  createOne,
  modifyOne,
  deleteOne,
  createSecondType,
  modifySecondType,
  deleteSecondType,
  fetchSecondTypeList
};



// WEBPACK FOOTER //
// ./src/api/business.js